<template>
  <v-card-text class="flex-shrink-1 overflow-y-auto">
    <template v-if="isGolfRequest">
      <p v-translate>
        Request to play golf with you
      </p>
      <p>
        <b>
          <translate>City</translate> : {{ friend.requestData.city.name }}
        </b>
      </p>
      <p v-if="friend.requestData.handicap">
        <b>
          <translate>Handicap</translate> : {{ friend.requestData.handicap }}
        </b>
      </p>
      <p>
        <b><translate>Available on</translate> :</b>
        <ul>
          <li>
            <translate>From</translate> : {{friend.requestData.dateFrom}} - <translate>to</translate> : {{friend.requestData.dateTo}}
          </li>
          <template v-for="(val, key) in friend.requestData">
            <li :key="key" v-if="key !== 'city' && key !== 'handicap' && key !== 'dateFrom' && key !== 'dateTo' && val">{{key}} : {{val}}</li>
          </template>
        </ul>
      </p>
    </template>
    <p v-else>
      {{ $gettext("This user sent you a friend request and are waiting for your confirmation") }}
    </p>

    <v-row class="ma-1">
      <v-btn
        color="primary"
        rounded
        class="text-none btn btn-register subtitle-2 mr-3"
        @click="acceptFriend()"
      >
        <strong><translate>Accept</translate></strong>
      </v-btn>
      <v-btn
        color="grey"
        rounded
        class="text-none btn btn-register subtitle-2"
        @click="denyFriend()"
      >
        <strong><translate>Deny</translate></strong>
      </v-btn>
    </v-row>
  </v-card-text>
</template>
<script>
import ChatService from "@/services/ChatService";
export default {
  props: {
    friend: {type: Object,default: () => {}},
  },
  data() {
    return {}
  },
  computed: {
    isGolfRequest() {
      return this.friend.requestData && this.friend.requestData.city
    }
  },
  methods: {
    async acceptFriend() {
      let result = await ChatService.acceptFriend(this.friend.user.id);
      if (!result.error) {
        this.$store.commit('chat/commitFriend', result.myFriend)
        this.$store.state.toggle.ChatFixedBottom.sendData({
          type: 'commitFriend',
          payload: result.theirFriend
        }, this.friend.user.id)
      }
    },
    async denyFriend() {
      let result = await ChatService.denyFriend(this.friend.user.id);
      if (!result.error) {
        this.$store.dispatch('chat/removeActiveChat', this.friend.user.id)
        this.$store.commit('chat/commitFriend', result.myFriend)
        this.$store.state.toggle.ChatFixedBottom.sendData({
          type: 'denyFriend',
          payload: result.theirFriend
        }, this.friend.user.id)
      }
    },
  },
};
</script>